import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
    loginSetFlowStageWatcher,
    loginWatcher,
    setTranslatableSuccessMessage,
    verifyEmailMfaCode
} from "../../redux/actions/loginactioncreators";
import flowStages from "../../flowStages";
import OtpCodeEntry from "./MfaOtpCodeEntry";
import { MfaPageContainer } from "./MfaPageContainer.jsx";
import { mfaToastMessages } from "../../i18n/mfaToastMessages.js";

export default function MfaEmail() {
    const dispatch = useDispatch()
    const mfaEmailConfig = useSelector((state) => state.loginForm.mfa.config.email);
    const otpCodeLength = mfaEmailConfig.codeLength;

    const [otpCodeValid, setOtpCodeValid] = useState();
    const [otpCode, setOtpCode] = useState();

    const challenge = useSelector((state) => state.loginForm.challenge);
    const username = useSelector((state) => state.loginForm.username);
    const password = useSelector((state) => state.loginForm.password);
    const accountNumber = useSelector((state) => state.loginForm.accountNumber);
    const email = useSelector((state) => state.loginForm.authToken.payload.email);
    const flowParameter = useSelector((state) => state.loginForm.flowParameter);
    const isSignUpFlow = flowParameter && flowParameter.toLowerCase() === "signup";
    
    useEffect(() => {
        if (challenge?.step === "MFA_SETUP_EMAIL_VERIFY") {
            dispatch(setTranslatableSuccessMessage(mfaToastMessages.emailVerificationCodeSent))
        }
    }, [challenge, mfaToastMessages, dispatch]);

    const handleResendVerificationCode = () => {
        const payload = {
            flowStage: flowStages.CHALLENGE_MFA_SETUP,
            challengeResponse: {
                session: challenge.session,
                challengeName: challenge.challengeName,
                step: "MFA_SETUP_EMAIL",
                challengeParameters: {
                    USERNAME: isSignUpFlow ? email : username,
                    RESEND: "true",
                    MFA_CONFIG: {
                        EMAIL: email
                    },
                    MFA_OPTIONS: challenge.challengeParameters["MFA_OPTIONS"] ?? undefined
                }
            },
            username: username,
            password: password,
            accountNumber: accountNumber
        };
        dispatch(loginWatcher(payload));
    };

    const otpOnChange = (value) => {
        setOtpCode(value);
        setOtpCodeValid(value.length === otpCodeLength);
    };

    const isOtpCodeValid = (value) => {
        return value.length === otpCodeLength;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (otpCodeValid) {
            dispatch(verifyEmailMfaCode({ code: otpCode, step: "MFA_SETUP_EMAIL_VERIFY" }));
        }
    }

    const handleClickBack = () => {
        dispatch(loginSetFlowStageWatcher({ flowStage: flowStages.MFA_SETUP }));
    }

    return (
        <div id="emailMfa">
            <MfaPageContainer
                onSubmit={handleSubmit}
                showErrors={true}
                requiredFields={[]}
                headerText={<FormattedMessage id="mfaSetup.emailSetup" defaultMessage="Email" description="Title for email MFA setup page" />}
                instructionalText={
                    <FormattedMessage
                        id="mfaSetup.emailSetupVerifyCode"
                        defaultMessage="Enter the code we just sent to your Email address. Please allow up to 2 minutes for the code to arrive. If you didn't receive the code, please check your spam folder."
                        description="Instructions for entering email verification code during MFA setup"
                    />
                }
                footNoteText={
                    <FormattedMessage
                        id="mfaSetup.accountRecoveryBlurb"
                        defaultMessage="Note: Once logged in, please verify a phone number in the settings menu of your account dashboard to be used as a recovery method for MFA."
                        description="Informational text about setting up phone number for account recovery"
                    />
                }
                submitButtonText={<FormattedMessage id="mfaSetup.continueButton" defaultMessage="Continue" description="Submit OTP code" />}
                secondaryButtonText={<FormattedMessage id="mfaSetup.backButton" defaultMessage="Back" description="Return to login" />}
                secondaryButtonHandler={handleClickBack}
                resendButtonText={<FormattedMessage id="mfa.resendOtpButton" defaultMessage="Resend Code" description="A button to request another one-time password to be sent" />}
                resendButtonHandler={handleResendVerificationCode}
                onChange={otpOnChange}
                otpValidator={isOtpCodeValid}
            >
                <OtpCodeEntry id="otpCodeEntry" length={otpCodeLength} onChange={otpOnChange} />
            </MfaPageContainer>
        </div >
    )
}